<template>
    <div class="SampleRequestEntry">
        <div class="SampleRequestColumn SampleRequestProduct">
            <div style="font-weight: bold;">{{ StyleNumber }}</div>
            <span :title="Product">{{ Product }}</span>
        </div>
        <div class="SampleRequestColumn SampleRequestAmount">
            <input :value="Amount" />
        </div>
        <div class="SampleRequestColumn SampleRequestOrderer">
            <input :value="Orderer" />
        </div>
        <div class="SampleRequestColumn SampleRequestReason">
            <textarea :value="Reason" />
        </div>
        <div class="SampleRequestColumn SampleRequestInCharge">
            <input :value="InCharge" />
        </div>
        <div class="SampleRequestColumn SampleRequestSampleType">
            <GenericDropdown :value="1" :options="SampleTypeOptions" :elementID="`${StyleNumber}_${ID}`" :SelectedIndex="SampleType"/>
        </div>
        <div class="SendSamplesRequestBtn SampleRequestColumn ButtonColumn" style="display: flex; flex-direction: unset;">
            <div class="Button ButtonGreen" title="アップデート" style="margin-right: 5px; margin-top: 2px; margin-bottom: 2px; border-radius: 50%; width: 32px;"><img style="width: 22px; height: auto;" src="../assets/Icon_Update.svg" /></div>
            <div class="Button" title="消す" style=""><img style="width: 36px; height: auto;" src="../assets/Icon_Cross.webp" /></div>
        </div>
    </div>
</template>

<script>
import GenericDropdown from './GenericDropdown.vue';

export default{
    props:{
        ID: Number,
        Product: String,
        StyleNumber: String,
        Amount: Number,
        Orderer: String,
        InCharge: String,
        Reason: String,
        SampleType: Number,
        SampleTypeOptions: Array,
        OnUpdateRequest: Function,
        OnDeleteRequest: Function
    },
    components:{
        GenericDropdown
    }
}
</script>

<style>
.SampleRequestEntry
{
    display: flex;
}

.SampleRequestEntry + .SampleRequestEntry
{
    margin-top: 15px;
}

.SampleRequestEntry .SampleRequestColumn
{
    align-items: unset;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.SampleRequestEntry .SampleRequestProduct
{
    width: 22vw;
}
</style>